import React from 'react';

import Collapse from '@editor/components/Collapse/Collapse';
import CollapseChild from '@editor/components/Collapse/CollapseChild';
import { FlexRow } from '@editor/components/utilities/layouts';
import { userStoreSelector, useUserStore } from '@editor/stores/userStore';
import { getUserCreditsInfo } from '@editor/utils/credits';
import { useCurrentPlan } from '@repo/subscription/client';
import CreditsIcon from '@repo/ui/components/Icon/CreditsIcon';
import { themeStyle } from '@repo/ui/theming';
import IconChevronUp from '@repo/ui-icons/IconChevronUp';
import { H5 } from '@repo/ui-kit/components/core/Typography';

import { UpgradePlanButton } from './CreditButtons';
import CreditsBalanceInfo, { UpgradeTrackingLabel } from './CreditsBalanceInfo';
import { ClosePanelIconWrapper, CreditsBalanceBannerWrapper } from './styles';

const CreditsBalanceBanner: React.FC = () => {
  const [isPanelOpen, setPanelOpen] = React.useState(false);
  const user = useUserStore(userStoreSelector.user);
  const currentPlan = useCurrentPlan();
  if (!user) {
    return null;
  }
  const { total } = getUserCreditsInfo(user);

  return (
    <Collapse
      theme={{
        backgroundColor: themeStyle.varInkSuperLight,
        outerPadding: '12px',
        borderRadius: isPanelOpen
          ? `${themeStyle.radiusMedium} ${themeStyle.radiusMedium} 0 0`
          : themeStyle.radiusMedium,
      }}
    >
      <CollapseChild
        hideRightIcon
        noTemplateColumns
        id="copy"
        labelContent={
          <FlexRow
            alignItems="center"
            data-testid="credits-balance-banner"
            justifyContent="space-between"
          >
            <FlexRow alignItems="center" gap="6px">
              <CreditsIcon height="16px" />
              <H5
                bold
                dataTestId="credits-balance-banner-total"
              >{`${total} Credits`}</H5>
            </FlexRow>
            {currentPlan ? (
              <ClosePanelIconWrapper isOpen={isPanelOpen}>
                <IconChevronUp color="var(--color-text-secondary)" size={16} />
              </ClosePanelIconWrapper>
            ) : (
              <UpgradePlanButton
                upgradeTrackingLabel={UpgradeTrackingLabel.KittlAiMenu}
              />
            )}
          </FlexRow>
        }
        onClick={() => {
          if (currentPlan) {
            setPanelOpen(!isPanelOpen);
          }
        }}
      >
        {currentPlan && (
          <CreditsBalanceBannerWrapper>
            <CreditsBalanceInfo
              upgradeTrackingLabel={UpgradeTrackingLabel.KittlAiMenu}
            />
          </CreditsBalanceBannerWrapper>
        )}
      </CollapseChild>
    </Collapse>
  );
};

export default CreditsBalanceBanner;
